import React from "react";
import HOC from "../../components/HOC";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import BreadcrumbBillingManual from "../../components/screen/billingManual/BreadcrumbBillingManual";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";
import DetailBillingManual from "../../components/screen/billingManual/DetailBillingManual";

const BillingManualDetailPage = ({ isWarehouse }) => {
  return (
    <div className="">
      <PageTemplate
        header={
          (isWarehouse ? "Central Warehouse " : "") + "Detail Billing Manual"
        }
        mainComponent={
          <ThemeProvider theme={theme}>
            <DetailBillingManual
              isWarehouse={isWarehouse ? isWarehouse : false}
            />
          </ThemeProvider>
        }
        breadcrumb={
          <BreadcrumbBillingManual
            isWarehouse={isWarehouse ? isWarehouse : false}
          />
        }
        pageRole={isWarehouse ? 29 : 9}
      />
    </div>
  );
};

export default HOC(BillingManualDetailPage);
